import { render, staticRenderFns } from "./PostulantsListTest.vue?vue&type=template&id=43a8ecba&scoped=true&"
import script from "./PostulantsListTest.vue?vue&type=script&lang=js&"
export * from "./PostulantsListTest.vue?vue&type=script&lang=js&"
import style0 from "./PostulantsListTest.vue?vue&type=style&index=0&id=43a8ecba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43a8ecba",
  null
  
)

export default component.exports